// extracted by mini-css-extract-plugin
export default {"swish-button":"App_swish-button__25IUe","modal-footer":"App_modal-footer__OsdUG","modal-swish-logo":"App_modal-swish-logo__xy9rk","modal-90-logo":"App_modal-90-logo__-lhz1"};